import React from 'react';
import PropTypes, { any } from 'prop-types';
import PrintCard from './PrintCard';
import styles from './matchScorePrintPage.scss';

const PrintTestPage = ({ match }) => {
    const clubLocationFacilityName = match?.params?.clubLocationFacilityName;

    return (
        <div className={styles.container}>
            <PrintCard
                type={'simple'}
                drawName={`Facility name: ${clubLocationFacilityName}`}
                matchPosition={'NA'}
                refereeName={'Test Page'}
                courtNumber={'NA'}
                scoringFormat={'NA'}
                scoringFormatDisplay={'Test Page'}
                displayNameOne={'Test Page'}
                displayNameTwo={'Test Page'}
                displayNameThree={'Test Page'}
                displayNameFour={'Test Page'}
                hasBreak={false}
            />
        </div>
    );
};

PrintTestPage.propTypes = {
    match: PropTypes.objectOf(any).isRequired,
};

export default {
    component: PrintTestPage,
};
